import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Reveal from './Reveal';

/** The closing conversion block. Appears at the foot of every page. */
const CTASection = ({
  title = 'Ready to take the next step?',
  subtitle = 'Tell us what you’re trying to build. We’ll tell you honestly whether we’re the right team for it.',
  primaryLabel = 'Start a conversation',
  primaryTo = '/contact',
  secondaryLabel = 'Browse our services',
  secondaryTo = '/services',
}) => (
  <section className="bg-light py-12 sm:py-16 md:py-24">
    <div className="container-page">
      <Reveal>
        <div className="relative overflow-hidden rounded-4xl bg-primary px-5 py-12 text-center shadow-lift sm:px-6 sm:py-14 md:rounded-5xl md:px-16 md:py-20">
          <div className="absolute inset-0 hero-wash" aria-hidden="true" />
          <div
            className="absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-secondary/10 blur-3xl"
            aria-hidden="true"
          />
          <div className="relative z-10 mx-auto max-w-2xl">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white">{title}</h2>
            <p className="mt-5 text-base md:text-lg text-white/70 leading-relaxed">{subtitle}</p>
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link to={primaryTo} className="btn-primary btn-lg w-full sm:w-auto group">
                {primaryLabel}
                <ArrowRight
                  size={18}
                  aria-hidden="true"
                  className="transition-transform group-hover:translate-x-1"
                />
              </Link>
              <Link to={secondaryTo} className="btn-ghost btn-lg w-full sm:w-auto">
                {secondaryLabel}
              </Link>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTASection;
